<template>
  <div class="activity-level-filter">
    <UiCheckbox
      v-for="item in checkboxItems"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :checked="item.checked"
      class="activity-level-filter__checkbox"
      @input="toggleValue(item.value)"
    >
      <template #hint>
        {{ item.description }}
      </template>
    </UiCheckbox>
  </div>
</template>

<script setup lang="ts">
  import { watch, ref, computed } from 'vue';
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { getActivityLevelFilterItems } from './consts';
  import { type TActivityLevelValue } from '@/features/filter/activity-level';
  import { useCategoryStore } from '@/shared/store';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';

  const categoryStore = useCategoryStore();

  const { MINIMUM, EASY, MEDIUM, HARD } = getActivityLevelFilterItems();

  const activityLevelItemsList = [MINIMUM, EASY, MEDIUM, HARD];

  const checkedValues = ref(new Set(categoryStore.tmpFilters[EExperienceFilterType.ACTIVITY_LEVEL].activity_level));

  const toggleValue = (value: TActivityLevelValue) => {
    if (checkedValues.value.has(value)) {
      checkedValues.value.delete(value);
    } else {
      checkedValues.value.add(value);
    }

    categoryStore.setActivityLevel(Array.from(checkedValues.value));
  };

  const checkboxItems = computed(() =>
    activityLevelItemsList.map((item) => ({
      ...item,
      checked: checkedValues.value.has(item.value),
    })),
  );

  watch(
    () => categoryStore.tmpFilters[EExperienceFilterType.ACTIVITY_LEVEL].activity_level,
    (newVal) => {
      checkedValues.value = new Set(newVal);
    },
  );
</script>

<style scoped lang="scss">
  .activity-level-filter {
    margin-top: 8px;
  }

  .activity-level-filter__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;
  }
</style>
